import React from 'react';
import { CheckIcon } from 'lucide-react';
import { useScrollAnimation } from './useScrollAnimation';
export function PricingSection() {
  const ref = useScrollAnimation();
  const sharedFeatures = ['10 Day Storm Guarantee', '1x Free Garbage Can or Window Track Cleaning Annually', 'Free Stain Treatment'];
  return <section id="pricing" className="w-full py-20 px-4" style={{
    backgroundColor: '#E8F4FD'
  }} data-id="element-146">
      <div className="max-w-7xl mx-auto" ref={ref} data-id="element-147">
        {/* Heading */}
        <div className="text-center mb-14 scroll-animate" data-id="element-148">
          <h2 className="font-bold mb-4" style={{
          fontFamily: 'Montserrat, sans-serif',
          fontSize: 'clamp(26px, 4vw, 40px)',
          color: '#0283C7',
          fontWeight: 800
        }} data-id="element-149">
            Residential &amp; Commercial Service Plans
          </h2>
          <p style={{
          color: '#374151',
          fontFamily: 'Inter, sans-serif',
          fontSize: '16px'
        }} data-id="element-150">
            $100 sign-up cost — service agreement included
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-start" data-id="element-151">
          {/* Monthly — FEATURED */}
          <div className="pop-animate flex flex-col overflow-hidden order-first md:order-none" style={{
          borderRadius: '16px',
          backgroundColor: '#0283C7',
          boxShadow: '0 12px 40px rgba(2,131,199,0.35)',
          animationDelay: '0.1s'
        }} data-id="element-152">
            <div className="px-6 py-2 text-center font-bold text-white text-xs tracking-widest uppercase" style={{
            backgroundColor: '#025A8A',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-153">
              ⭐ Most Popular
            </div>
            <div className="p-7" data-id="element-154">
              <p className="font-bold text-white opacity-70 mb-1 uppercase tracking-widest text-xs" style={{
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-155">
                Monthly Cleaning
              </p>
              <div className="font-bold text-white mb-1" style={{
              fontFamily: 'Montserrat, sans-serif',
              fontSize: '52px',
              lineHeight: 1,
              fontWeight: 900
            }} data-id="element-156">
                $150 Off
              </div>
              <p className="font-bold text-white mb-3" style={{
              fontFamily: 'Montserrat, sans-serif',
              fontSize: '16px'
            }} data-id="element-157">
                Lock in Your Price for Life!
              </p>
              <p className="text-white opacity-80 mb-6" style={{
              fontFamily: 'Inter, sans-serif',
              fontSize: '14px',
              lineHeight: 1.6
            }} data-id="element-158">
                Keep your property spotless year-round with our monthly power
                washing service. Perfect for high-traffic areas.
              </p>
              <ul className="flex flex-col gap-3 mb-7" data-id="element-159">
                {['15% OFF Any Other Service', ...sharedFeatures].map(f => <li key={f} className="flex items-start gap-3" data-id="element-160">
                    <CheckIcon className="h-5 w-5 flex-shrink-0 mt-0.5 text-white" data-id="element-161" />
                    <span className="text-white text-sm" style={{
                  fontFamily: 'Inter, sans-serif',
                  lineHeight: 1.5
                }} data-id="element-162">
                      {f}
                    </span>
                  </li>)}
              </ul>
              <a href="#contact" className="font-bold text-center block py-3.5 rounded-lg transition-all hover:scale-[1.02]" style={{
              backgroundColor: '#ffffff',
              color: '#0283C7',
              fontFamily: 'Inter, sans-serif',
              fontSize: '15px',
              borderRadius: '8px'
            }} data-id="element-163">
                Get a Free Quote
              </a>
            </div>
          </div>

          {/* Quarterly */}
          <div className="pop-animate bg-white flex flex-col overflow-hidden" style={{
          borderRadius: '16px',
          boxShadow: '0 4px 20px rgba(2,131,199,0.1)',
          border: '2px solid #0283C7',
          animationDelay: '0.2s'
        }} data-id="element-164">
            <div className="p-7" data-id="element-165">
              <p className="font-bold opacity-60 mb-1 uppercase tracking-widest text-xs" style={{
              color: '#0283C7',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-166">
                Quarterly Cleaning
              </p>
              <div className="font-bold mb-1" style={{
              fontFamily: 'Montserrat, sans-serif',
              fontSize: '52px',
              color: '#0283C7',
              lineHeight: 1,
              fontWeight: 900
            }} data-id="element-167">
                $100 Off
              </div>
              <p className="font-bold mb-3" style={{
              fontFamily: 'Montserrat, sans-serif',
              fontSize: '16px',
              color: '#0283C7'
            }} data-id="element-168">
                Lock in Your Price for Life!
              </p>
              <p className="mb-6" style={{
              color: '#374151',
              fontFamily: 'Inter, sans-serif',
              fontSize: '14px',
              lineHeight: 1.6
            }} data-id="element-169">
                Maintain a clean and inviting property every season. Ideal for
                regular upkeep.
              </p>
              <ul className="flex flex-col gap-3 mb-7" data-id="element-170">
                {['10% OFF Any Other Service', ...sharedFeatures].map(f => <li key={f} className="flex items-start gap-3" data-id="element-171">
                    <CheckIcon className="h-5 w-5 flex-shrink-0 mt-0.5" style={{
                  color: '#0283C7'
                }} data-id="element-172" />
                    <span className="text-sm" style={{
                  color: '#374151',
                  fontFamily: 'Inter, sans-serif',
                  lineHeight: 1.5
                }} data-id="element-173">
                      {f}
                    </span>
                  </li>)}
              </ul>
              <a href="#contact" className="font-bold text-white text-center block py-3.5 rounded-lg transition-all hover:scale-[1.02]" style={{
              backgroundColor: '#0283C7',
              fontFamily: 'Inter, sans-serif',
              fontSize: '15px',
              borderRadius: '8px'
            }} data-id="element-174">
                Get a Free Quote
              </a>
            </div>
          </div>

          {/* Bi-Annual */}
          <div className="pop-animate bg-white flex flex-col overflow-hidden" style={{
          borderRadius: '16px',
          boxShadow: '0 4px 20px rgba(2,131,199,0.1)',
          border: '2px solid #0283C7',
          animationDelay: '0.3s'
        }} data-id="element-175">
            <div className="p-7" data-id="element-176">
              <p className="font-bold opacity-60 mb-1 uppercase tracking-widest text-xs" style={{
              color: '#0283C7',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-177">
                Bi-Annual Cleaning
              </p>
              <div className="font-bold mb-1" style={{
              fontFamily: 'Montserrat, sans-serif',
              fontSize: '52px',
              color: '#0283C7',
              lineHeight: 1,
              fontWeight: 900
            }} data-id="element-178">
                $50 Off
              </div>
              <p className="font-bold mb-3" style={{
              fontFamily: 'Montserrat, sans-serif',
              fontSize: '16px',
              color: '#0283C7'
            }} data-id="element-179">
                Lock in Your Price for Life!
              </p>
              <p className="mb-6" style={{
              color: '#374151',
              fontFamily: 'Inter, sans-serif',
              fontSize: '14px',
              lineHeight: 1.6
            }} data-id="element-180">
                Twice-a-year power washing for seasonal refreshes and long-term
                maintenance.
              </p>
              <ul className="flex flex-col gap-3 mb-7" data-id="element-181">
                {['5% OFF Any Other Service', ...sharedFeatures].map(f => <li key={f} className="flex items-start gap-3" data-id="element-182">
                    <CheckIcon className="h-5 w-5 flex-shrink-0 mt-0.5" style={{
                  color: '#0283C7'
                }} data-id="element-183" />
                    <span className="text-sm" style={{
                  color: '#374151',
                  fontFamily: 'Inter, sans-serif',
                  lineHeight: 1.5
                }} data-id="element-184">
                      {f}
                    </span>
                  </li>)}
              </ul>
              <a href="#contact" className="font-bold text-white text-center block py-3.5 rounded-lg transition-all hover:scale-[1.02]" style={{
              backgroundColor: '#0283C7',
              fontFamily: 'Inter, sans-serif',
              fontSize: '15px',
              borderRadius: '8px'
            }} data-id="element-185">
                Get a Free Quote
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}